export default {
  primary: 'OpenSans-Light',
  primary_alt: 'OpenSans-Light',
  secondary: 'OpenSans-Regular',
  secondarySemiBold: 'OpenSans-SemiBold',
  secondaryBold: 'OpenSans-Bold',
};
